import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ComponentsModule } from './components/components.module';
import { MaterialUiModule } from './material-ui-module/material-ui.module';
import { PipesModule } from './pipes/pipes.module';
import { DirectivesModule } from './directives/directives.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectivesModule,
    MaterialUiModule,
    PipesModule,
    ReactiveFormsModule
  ],
  exports: [
    ComponentsModule,
    DirectivesModule,
    FlexLayoutModule,
    MaterialUiModule,
    PipesModule,
    FontAwesomeModule
  ]
})
export class SharedModule {}
